import { Button, Modal, Typography } from '~/components';
import { Icon, getTheme, pxToRem, styled } from '~/modules';

const textMain = getTheme('text.main');

const spacingMd = getTheme('spacing.md');
const spacingLg = getTheme('spacing.lg');
const spacingXl = getTheme('spacing.xl');

export const Wrapper = styled(Modal)`
  width: ${pxToRem(500)};
  max-width: 90%;
  flex-direction: column;
  padding: ${spacingXl}px;
`;

export const ModalIcon = styled(Icon)`
  font-size: ${pxToRem(54)};
  color: ${textMain};
`;

export const ButtonComponent = styled(Button)`
  margin-top: ${spacingLg}px;
`;

export const Title = styled(Typography).attrs({ variant: 'xl' })`
  text-align: center;
  margin-bottom: ${spacingMd}px;
  margin-top: ${spacingMd}px;
`;

export const Description = styled(Typography)`
  opacity: 0.8 !important;
  text-align: center;
  font-size: ${pxToRem(15)};
`;
